// src/Dashboard/pages/user/Produits/ProduitsDashboard.jsx

import React from "react";

import useProductsDashboard from "./hooks/useProductsDashboard";

import DeveloperHeroCard from "./components/DeveloperHeroCard";
import ProductsToolbar from "./components/ProductsToolbar";
import ProductsGrid from "./components/ProductsGrid";
import ProductDrawer from "./components/ProductDrawer";

export default function ProduitsDashboard() {
  const {
    products,
    filteredProducts,
    loading,
    error,
    ui,
    debouncedQ,
    setDebouncedQ,
    updateUi,
    resetFilters,
    refreshProducts,
    shareCopied,
    copyShareLink,
    selectedProduct,
    openProductDrawer,
    closeProductDrawer,
  } = useProductsDashboard();

  return (
    <section className="w-full">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-6 px-3 py-4 sm:px-6 lg:px-8">
        <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

          <div className="px-4 py-5 sm:px-6">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                  MonAppliClub
                </p>

                <h1 className="mt-2 text-2xl font-bold text-slate-950 dark:text-white sm:text-3xl">
                  Mes applications
                </h1>

                <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
                  Découvrez les applications que je développe pour les clubs,
                  enseignants, associations, collectivités et structures
                  sportives.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap">
                <div className="rounded-2xl bg-slate-50 px-4 py-3 text-center ring-1 ring-slate-200 dark:bg-slate-800/60 dark:ring-slate-700">
                  <p className="text-xl font-bold text-slate-900 dark:text-white">
                    {products.length}
                  </p>
                  <p className="text-xs text-slate-500 dark:text-slate-400">
                    applications
                  </p>
                </div>

                <div className="rounded-2xl bg-slate-50 px-4 py-3 text-center ring-1 ring-slate-200 dark:bg-slate-800/60 dark:ring-slate-700">
                  <p className="text-xl font-bold text-slate-900 dark:text-white">
                    {filteredProducts.length}
                  </p>
                  <p className="text-xs text-slate-500 dark:text-slate-400">
                    affichées
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <DeveloperHeroCard />

        <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <div className="bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#4CA82F] px-5 py-6 text-white sm:px-7">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
              <div>
                <h2 className="text-xl font-bold">
                  Catalogue d’applications
                </h2>

                <p className="mt-1 max-w-3xl text-sm leading-6 text-white/90">
                  Recherchez une application, consultez sa présentation et
                  ouvrez les exemples disponibles.
                </p>
              </div>

              <button
                type="button"
                onClick={refreshProducts}
                className="inline-flex items-center justify-center rounded-2xl bg-white/15 px-4 py-3 text-sm font-bold text-white ring-1 ring-white/25 transition hover:bg-white/25"
              >
                Rafraîchir
              </button>
            </div>
          </div>

          <div className="border-b border-slate-200 p-4 dark:border-slate-800 sm:p-6">
            <ProductsToolbar
              ui={ui}
              debouncedQ={debouncedQ}
              setDebouncedQ={setDebouncedQ}
              onChange={updateUi}
              onReset={resetFilters}
              onShare={copyShareLink}
              shareCopied={shareCopied}
              resultCount={filteredProducts.length}
            />
          </div>

          <div className="p-4 sm:p-6">
            <ProductsGrid
              products={filteredProducts}
              loading={loading}
              error={error}
              onOpenProduct={openProductDrawer}
            />
          </div>
        </div>

      </div>

      <ProductDrawer
        product={selectedProduct}
        isOpen={!!selectedProduct}
        onClose={closeProductDrawer}
      />
    </section>
  );
}